
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/monthly-payments-calculator",
      function () {
        return require("private-next-pages/tools/monthly-payments-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/monthly-payments-calculator"])
      });
    }
  